import {
  BedDouble,
  CarTaxiFront,
  Clock4,
  type LucideIcon,
  PhoneOutgoing,
  PlaneLanding,
  PlaneTakeoff,
  Receipt,
  TentTree,
  TrainFront,
  UtensilsCrossed,
} from "lucide-react";

import type { ClaimExpenseInput } from "@upclaim/sdk/src/data-contracts";

export type ExpenseType = ClaimExpenseInput["expense"]["expenseType"];
export type ExpenseMonetaryDemandType = NonNullable<ClaimExpenseInput["monetaryDemandType"]>;

/** Port of utils/config/constants/expenses-types.ts (Vue). */
export const expenseTypesMap: Record<ExpenseType, { icon: LucideIcon; value: ExpenseType; label: string }> = {
  TRAIN: { icon: TrainFront, value: "TRAIN", label: "Train" },
  HOTEL: { icon: BedDouble, value: "HOTEL", label: "Hébergement" },
  TAXI: { icon: CarTaxiFront, value: "TAXI", label: "Taxi / Uber" },
  OUTBOUND_FLIGHT: { icon: PlaneLanding, value: "OUTBOUND_FLIGHT", label: "Billet d'avion retour" },
  RETURN_FLIGHT: { icon: PlaneTakeoff, value: "RETURN_FLIGHT", label: "Billet d'avion aller" },
  FOOD: { icon: UtensilsCrossed, value: "FOOD", label: "Frais de restauration" },
  PHONE_PLAN: { icon: PhoneOutgoing, value: "PHONE_PLAN", label: "Hors forfait téléphonique" },
  TRAVEL_PACKAGE_SERVICE: {
    icon: TentTree,
    value: "TRAVEL_PACKAGE_SERVICE",
    label: "Prestation forfait voyage",
  },
  SALARY_COMPENSATION: { icon: Clock4, value: "SALARY_COMPENSATION", label: "Compensation salaire" },
  OTHER: { icon: Receipt, value: "OTHER", label: "Autre" },
};

/** Expense types reimbursable under the EU261 assistance duty (Vue get-monetary-demand-type.ts). */
const expenseTypesUnderEC261: ExpenseType[] = [
  "TRAIN",
  "HOTEL",
  "OUTBOUND_FLIGHT",
  "RETURN_FLIGHT",
  "FOOD",
  "TRAVEL_PACKAGE_SERVICE",
];

export function getExpenseMonetaryDemandType(
  isLostPrestation: boolean,
  expenseType: ExpenseType,
): { id: number; type: ExpenseMonetaryDemandType } {
  if (!isLostPrestation && expenseTypesUnderEC261.includes(expenseType)) {
    return { id: 8, type: "EC261_ASSISTANCE_DUTY" };
  }
  return { id: 2, type: "MC99_FINANCIAL_DAMAGES" };
}
